import * as React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { actionCreators, Verify2FASteps } from '../../store/Auth/Verification2FAStore';
import Octicon, { getIconByName } from '@github/octicons-react'; //https://octicons.github.com/
import SilvermouseInfo from './SilvermouseInfo';
import '../../css/auth.css';
import { AppLogo } from '../Controls/AppLogo';
import { IsSoundmouse } from '../../tools/toolkit';
import { isStringNullOrWhiteSpace } from '../../tools/validator';
import { Verify2FA } from '../../apiRoutes';

class Verification2FA extends React.Component {

    
    componentWillMount() {
        this.props.get2FADetail();
    }

    componentDidUpdate() {
        // Its all not that great. It would be better if every view would be its own component
        // which would be rendered within a kind of "master" component for the 2fa workflow.
        // Not that if-else nonsense. Most likely we could just pass a state (controlled by the reducer)
        // in a property to indicate if the comonent is "visible/disabled". Then the current component
        // here would have almost no logic and so would the referred components for each step.
        // Benefit: 90% complexity reduction
        // 
        if (this.props.resendCounter === 0) {
            this.addResendTimer();
        }
        
    }

    addResendTimer() {
        if (this.props.step === Verify2FASteps.VerifyCode
            || this.props.step === Verify2FASteps.SendCodeToEmail
            || this.props.step === Verify2FASteps.SendCodeToMobile) {
            setTimeout(() => {
                if (this.props.resendCounter < this.props.maxResendAttempts) {
                    this.props.enableResend();
                }
                
            }, this.props.data.resendTimeout * 1000);
        }
        else
            this.props.disableResend();
    }

    handleVerifyEmail = (event) => {
        event.preventDefault();

        if (this.props.step === Verify2FASteps.Introducing) {
            this.props.verifyIntroducing();
        }
        else if (this.props.step === Verify2FASteps.VerifyMobile) {
            this.props.verifyMobileNumber(this.refs.mobileNumber.value);
            this.refs.mobileNumber.value = '';
        }
        else if (this.props.step === Verify2FASteps.VerifyCode) {
            this.props.verify(this.refs.code.value);
            this.refs.code.value = '';
        }
    }

    handleResend = (event) => {
        event.preventDefault();
        // we probably cna let the api send the max numbers
        if (this.props.resendCounter <= this.props.maxResendAttempts) {
            if (this.props.resendCounter < this.props.maxResendAttempts) {
                this.addResendTimer();
            }

            this.props.sendCode(this.props.previousStep);
        }

        this.props.disableResend();
    }

    handleSendCodeToEmail = (event) => {
        event.preventDefault();
        this.props.sendCode(Verify2FASteps.SendCodeToEmail);
    }

    handleSendCodeToMobile = (event) => {
        event.preventDefault();
        this.props.sendCode(Verify2FASteps.SendCodeToMobile);
    }

    handleSkip2FA = (event) => {
        event.preventDefault();
        this.props.skip2FA(this.props.username);
    }

    renderWarningMessage() {
        if (this.props.hasErrorOccured) {
            return (
                <h3 className='form-group text-left'>
                    <Octicon icon={getIconByName('alert')} className='text-warning mr-2' />
                    {this.props.errorData.message}
                </h3>
            );
        }
    }

    renderIcon() {
        let iconClass = 'dotPrimary';

        if (this.props.hasErrorOccured) {
            iconClass = 'dotError';
        }
        else if (this.props.step === Verify2FASteps.Verified) {
            iconClass = 'dotSuccess';
        }

        return <Octicon icon={getIconByName(this.props.iconName)} className={`dot ${iconClass}`} />;
    }

    renderSkip2FAPart() {
        if (this.props.data.canSkip) {
            return (
                <div>
                    <br />
                    <Octicon icon={getIconByName('arrow-right')} className={'dot dotPrimary'} />
                    <p>If you wish to complete the process later, please click the Skip button below to enter the site.</p>
                    <br />
                    <p>The Skip button is available for 90 days from the point you first skip 2FA.</p>
                    <br />
                    <div className='form-group text-right'>
                        <button className='button button-primary' onClick={this.handleSkip2FA}>Skip</button>
                    </div>
                </div>
            );
        }
        return '';
    }

    renderMobileSendButton() {
        if (isStringNullOrWhiteSpace(this.props.data.mobile)) {
            return '';
        }

        return <button className='button button-primary' onClick={this.handleSendCodeToMobile} >Send</button>;
    }

    render2FA() {

        if (this.props.step === Verify2FASteps.EmailVerification) {
            return <Redirect to='/EmailVerification' />;
        }

        // Intro.
        if (this.props.step === Verify2FASteps.Introducing) {
            return (
                <div>
                    <h2 className='mt-2'>Two factor authentication available</h2>
                    <p>Two factor authentication (2FA) is now available for your account. Please click on the Proceed button below to setup 2FA. You will need access to your registered email address in order to receive a code to complete the process.</p>
                    <br />
                    <div className='form-group text-right'>
                        <button className='button button-primary' onClick={this.handleVerifyEmail} >Proceed</button>
                    </div>
                    {this.renderSkip2FAPart()}
                </div>
            );
        }
        // Account is disabled.
        else if (this.props.step === Verify2FASteps.Disabled) {
            return (
                <div>
                    <h2 className='mt-2'>Account disabled</h2>
                    <p>There have been more than 10 failed attempts to provide a valid code. Your account has now been disabled. Please contact support to re-enable your account.</p>
                    <br />
                    <p>An email confirming that your account is disabled has been sent to your registered email address.</p>
               </div>
           );
        }
        else if (this.props.step === Verify2FASteps.Logout) {
            return <SilvermouseInfo />;
        }
        // Request code.
        else if (this.props.step === Verify2FASteps.SendingCode) {
            return (
                <div>
                    <h2 className='mt-2'>Request your 2FA code</h2>
                    <p>Please click on the Send button below to receive an email with your 2FA code to your registered email address.</p>
                    <br />
                    <div className='row border border-info p-2 m-0'>
                        <div className='col-md-1 text-left pl-1'>
                            <Octicon icon={getIconByName('mail')} className={`dot dotPrimary`} />
                        </div>
                        <div className='col-md-8 text-left'>
                            <div className='mb-1'>Send code to your email address</div>
                            <span className='text-muted'>{this.props.data.email}</span>
                        </div>
                        <div className='col-md-3 text-right p-0'>
                            <button className='button button-primary' onClick={this.handleSendCodeToEmail}>Send</button>
                        </div>
                    </div>
                    <div className='row border border-info p-2 m-0 mt-3'>
                        <div className='col-md-1 text-left pl-1'>
                            <Octicon icon={getIconByName('device-mobile')} className={`dot dotPrimary`} />
                        </div>
                        <div className='col-md-8 text-left'>
                            <div className='mb-1'>Send code to your mobile phone*</div>
                            <span className='text-muted'>{this.props.data.mobile}</span>
                        </div>
                        <div className='col-md-3 text-right p-0'>
                            {this.renderMobileSendButton()}
                        </div>
                    </div>
                    <div className='col-md-10 text-left mt-1'>
                        <p>* A mobile number can be registered in the Account Settings by clicking on the user icon within the Silvermouse/Soundmouse platform.</p>
                    </div>
                    {this.renderSkip2FAPart()}
                </div>
            );
        }
        // Verify mobile (TBC)
        else if (this.props.step === Verify2FASteps.VerifyMobile) {
            return (
                <div>
                    <h2 className='mt-2'>Enter Your Mobile Number</h2>
                    <p>....</p>
                    <br />
                    <div className='form-group'>
                        <input id='mobileNumber' ref='mobileNumber' type='number' maxLength='11' className='form-control' placeholder='Enter mobile number' autoComplete='off' required onKeyDown={(e) => { if (e.key === 'Enter' && e.shiftKey === false) this.handleVerifyEmail(e); }} />
                    </div>
                    <div className='form-group text-right'>
                        <button className='button button-primary' onClick={this.handleVerifyEmail} >Send</button>
                    </div>
                </div>
            );
        }
        // Enter code.
        else if (this.props.step === Verify2FASteps.VerifyCode) {
            var button = <button className='button button-primary w-25 mr-2 btn-disabled' disabled="true" onClick={this.handleResend} >Resend</button>;

            if (this.props.canResend) {
                button = <button className='button button-primary w-25 mr-2' onClick={this.handleResend}>Resend</button>;
            }

            return (
                <div>
                    <h2 className='mt-2'>Enter your 2FA code</h2>
                    <p>Please enter your 2FA code in the box below and click on the Submit button.</p>
                    <br />
                    <p>If you do not receive your code within a few minutes, please click on the Resend button to receive a new code. Any previous codes will no longer be valid once you click Resend.</p>
                    <br />
                    <p>You are only able to resend a new code up to {this.props.maxResendAttempts} times.</p>
                    <br />
                    <div className='form-group'>
                        <input id='code' ref='code' type='text' className='form-control' placeholder='Enter the code' autoComplete='off' required onKeyDown={(e) => { if (e.key === 'Enter' && e.shiftKey === false) this.handleVerifyEmail(e); }} />
                    </div>
                    <div className='form-group text-right'>
                        {button}
                        <button className='button button-primary' onClick={this.handleVerifyEmail}>Submit</button>
                    </div>
                    {this.renderSkip2FAPart()}
                </div>
            );
        }

        return '';
    }

    render() {
        if (this.props.skip2FASteps || this.props.step === Verify2FASteps.Verified) {
            return <Redirect to={{ pathname: '/Gateway', redirectUri: this.props.gatewayUri }} />;
        }

        let logoAlign = 'text-left';

        if (IsSoundmouse) {
            logoAlign = 'text-center';
        }

        return (
            <div role='main' className='pt-3'>
                <h1 class='visuallyhidden'>Two Factor Authentication Page</h1>
                <div className='row justify-content-center'>
                    <div className='text-center'>
                        <div className='loginLogo'>
                            <div className={logoAlign}>
                                <AppLogo />
                            </div>
                        </div>
                        <div className='loginVerificationBox'>
                            <div className='text-left'>
                                {this.renderIcon()}
                                <form>
                                    {this.render2FA()}
                                    {this.renderWarningMessage()}
                                </form>
                                <br />
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

export default connect(
    state => state.verification2FA,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Verification2FA);



// WEBPACK FOOTER //
// ./src/components/Auth/Verification2FA.js